var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePeople = function SvgGooglePeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_people_svg__a",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#34A853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FBBC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 8,
    fill: "url(#google_people_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_people_svg__a)",
    d: "M8 40c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v2H8z"
  })));
};
export default SvgGooglePeople;